import {FacetState} from "models/FacetsState"
import {BRAND_0_9} from "../../config/constants"
import isNumeric from "../isNumeric"

export const sortFacetAlphabatically = (facets: string[]) => {
    const sortedFacets = facets.reduce((acc, filter) => {
        const filterName = filter.split(":")
        const firstChar = filterName[1]?.substring(0, 1).toUpperCase()
        if (Object.prototype.hasOwnProperty.call(acc, firstChar) && !isNumeric(firstChar)) {
            acc[firstChar].push(filter)
        } else if (isNumeric(firstChar)) {
            if (acc[BRAND_0_9]) acc[BRAND_0_9].push(filter)
            else acc[BRAND_0_9] = [filter]
        } else {
            acc[firstChar] = [filter]
        }

        return acc
    }, {})
    return sortedFacets
}

export const sortFacetStateAlphabatically = (facets: FacetState[]) => {
    const sortedFacets = facets.reduce((acc, filter) => {
        const filterName = filter.v.split(":")
        const firstChar = filterName[1]?.substring(0, 1).toUpperCase()
        if (Object.prototype.hasOwnProperty.call(acc, firstChar) && !isNumeric(firstChar)) {
            acc[firstChar].push(filter)
        } else if (isNumeric(firstChar)) {
            if (acc[BRAND_0_9]) acc[BRAND_0_9].push(filter)
            else acc[BRAND_0_9] = [filter]
        } else {
            acc[firstChar] = [filter]
        }

        return acc
    }, {})
    return sortedFacets
}
